import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LineClampTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'lines',
})<{ lines?: number }>(({ lines = 2 }) => ({
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
